module.exports = __webpack_public_path__ + "static/media/iot-solution01.07281b43.jpg";